export const getStyles = (
  columns: number,
  isMobile: boolean,
  isTablet: boolean,
) => {
  let columnValue = columns;
  if (isTablet) columnValue = 2;
  if (isMobile) columnValue = 1;

  return {
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: `repeat(${columnValue}, 1fr)`,
      gridGap: '0.25rem',
      margin: '0 auto',
    },
  };
};
